import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';

export function catalogFormWizardFields(translate: TranslateService): FormlyFieldConfig[] {
  return [
    {
      fieldGroupClassName: 'flex gap-2 w-full mb-2',
      fieldGroup: [
        {
          key: 'name',
          type: 'input',
          className: 'flex-1',
          props: {
            label: translate.instant('CATALOG.INTERNAL_NAME'),
            required: true,
          },
        },
        {
          key: 'title',
          type: 'input',
          className: 'flex-1',
          props: {
            label: translate.instant('CATALOG.TITLE'),
            required: true,
          },
        },
      ],
    },
    {
      key: 'extraFields',
      type: 'repeat',
      props: { addText: translate.instant('CATALOG.ADD_EXTRA_FIELD') },
      fieldArray: {
        fieldGroup: [
          {
            key: 'key',
            type: 'input',
            className: 'flex-1',
            props: { label: translate.instant('CATALOG.EXTRA_FIELD_KEY'), required: true },
          },
          {
            key: 'value',
            type: 'input',
            className: 'flex-1',
            props: { label: translate.instant('CATALOG.EXTRA_FIELD_VALUE'), required: true },
          },
        ],
      },
    },
  ];
}
